<template>
<div>
<li >
 <!-- <div class="left">
 <span>区域城市</span>
 </div> -->
 <div class="right r">
 <div class="city" @click="toAddress">{{city}}</div>
 <i class="arrow-r"> </i>
 </div>
</li>
<v-distpicker type="mobile" @selected='selected' v-show="addInp" class="area1">
</v-distpicker>
<div class="mask" v-show="mask"></div>
 
</div>
 
  
</template>
 
<script>
import VDistpicker from 'v-distpicker'
 
 export default {
 components: { VDistpicker },
 name:"area1",
 data(){
 return{
 city:'区域城市',
 addInp :false,
 mask:false
 }
 },
 methods:{
 toAddress(){
 this.mask = true;
 this.addInp = true;
},
 // 省市区三级联动
 selected(data){
 this.mask =false;
 this.addInp = false;
 this.city = data.province.value + ' ' + data.city.value +' ' + data.area.value;
 this.$emit('parentFunc', this.city)
 },

 }
 }
</script>
 
<style scoped>
 li{
 list-style: none;
 }
 .area1{
 width: 100%;
 height: 45%;
 position:fixed;
 z-index: 99;
 left: 0;
 bottom: 0;
 overflow-y: scroll;
 }
 .distpicker-address-wrapper .address-header ul{
 position:fixed !important;
 left: 0 !important;
 top: 0 !important;
 }
 .city{
  line-height: .82rem;
 }
</style>